import { ErrorResponse } from '../interfaces'
import { ApiErrorResponse, ErrorValidationResponse  } from '../interfaces/Error/ErrorResponse'

const isAspNetValidationError = (data: any): data is ErrorValidationResponse => {
  return data !== null && 
         data !== undefined && 
         typeof data === 'object' &&
         data.errors && 
         typeof data.errors === 'object' &&
         (data.title !== undefined || data.type !== undefined || data.status !== undefined)
}

const isLegacyErrorResponse = (data: any): data is ErrorResponse => {
  return data !== null && 
         data !== undefined && 
         typeof data === 'object' &&
         typeof data.message === 'string'
}


export const generateErrorFromResponse = ({
  data
}: {
  data: ApiErrorResponse
}): string => {
  // Valida el tipo de respuesta
  if (!data || data === null || data === undefined) {
    return 'Ha ocurrido un error inesperado. Vuelva a intentar en un momento. Si el problema persiste, contacte al administrador.'
  }

  // Algunas respuestas de error llegan como JSON sin parsear (el backend no
  // envía Content-Type: application/json), por lo que axios deja el body como string
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data)
    } catch {
      return data
    }
  }

  // Manejo de nuevo formato de respuesta
  if (isAspNetValidationError(data)) {
    const errors = data.errors || {}
    const errorMessages: string[] = []
    
    // Extrae todos los mensajes de error
    Object.values(errors).forEach(fieldErrors => {
      if (Array.isArray(fieldErrors)) {
        errorMessages.push(...fieldErrors)
      }
    })
    
    if (errorMessages.length > 0) {
      return errorMessages.join('\n')
    }
    
    return data.title || 'Errores de validación encontrados'
  }

  // MANEJO del formato actual del error response
  if (isLegacyErrorResponse(data)) {
    return data.message
  }

  // En caso de cualquier otro formato
  if (typeof data === 'string') {
    return data
  }
  
  // Si tiene message pero no pasó el type guard
  if (data && typeof data === 'object' && data.message) {
    return String(data.message)
  }

  return 'Ha ocurrido un error inesperado. Vuelva a intentar en un momento. Si el problema persiste, contacte al administrador.'
}

